import { useEffect, useState } from "react";
import {
  Document,
  Text,
  Page,
  StyleSheet,
  View,
  Image,
} from "@react-pdf/renderer";
import { Table, TR, TH, TD } from "@ag-media/react-pdf-table";
import moment from "moment-timezone";

import logo from "../../images/logo.png";
import seedrandom from "seedrandom";

const PreventativeReportDocument = (props) => {
  const [data, setData] = useState();

  useEffect(() => {
    const tempData = props.data.records.maintenancesLog;
    var i = 0;
    tempData.forEach((item) => {
      item.maintenances = item.maintenances.filter((maintenance) => {
        if (moment(props.date).month() === 11) {
          if (i < 10) {
            i += 1;
            return true;
          }
          return false;
        }
        if (maintenance.period * 1 === 90) {
          const month = moment(props.date).month();
          if (month === 1 || month === 4 || month === 7 || month === 10) {
            return true;
          }
          return false;
        }
        if (maintenance.period * 1 === 365) {
          const month = moment(props.date).month();
          if (month === 11) {
            return true;
          }
          return false;
        }
        return true;
      });
    });

    setData(tempData);
  }, []);

  const randomDate = (seed) => {
    const rng = seedrandom(seed);
    const random = rng();

    const d = moment(props.date);
    const start = moment(d.startOf("month"));
    const end =
      d.month() === 11 ? moment(d.add(5, "days")) : moment(d.endOf("month"));

    const randomTimestamp =
      start.valueOf() + random * (end.valueOf() - start.valueOf());

    const randomDt = moment(randomTimestamp);
    return randomDt;
  };

  const styles = StyleSheet.create({
    page: {
      paddingTop: 15,
      paddingBottom: 85,
      paddingHorizontal: 35,
      margin: 10,
    },
    text: {
      margin: 10,
      fontSize: 14,
      textAlign: "justify",
      fontFamily: "Times-Roman",
    },
    logo: {
      width: 150,
      height: 50,
    },
    fixedHeader: {
      flexDirection: "row",
      marginBottom: 10,
    },
    title: {
      marginLeft: 30,
      marginTop: 7,
      fontSize: 19,
      fontFamily: "Courier-Bold",
    },
    border: {
      position: "absolute",
      border: "1pt solid #000",
      width: 575,
      height: 820,
    },
    pageNumber: {
      marginTop: 5,
      marginLeft: 50,
    },
    tData: {
      paddingTop: 2,
      paddingLeft: 5,
      paddingBottom: 2,
      paddingRight: 10,
      fontSize: 10,
    },
    tHeaderData: {
      fontFamily: "Helvetica-Bold",
      paddingLeft: 3,
      paddingRight: 3,
      paddingBottom: 2,
      fontSize: 10,
    },
    tDataMin: {
      paddingTop: 2,
      paddingLeft: 5,
      paddingBottom: 2,
      paddingRight: 10,
      fontSize: 9,
    },
    tHeaderDataMin: {
      fontFamily: "Helvetica-Bold",
      paddingTop: 3,
      paddingLeft: 5,
      paddingRight: 5,
      paddingBottom: 2,
      fontSize: 9,
      justifyContent: "center",
    },
  });

  return data ? (
    <Document>
      <Page size="A4" style={styles.page}>
        <View fixed style={styles.border} />
        <View fixed style={styles.fixedHeader}>
          <Image src={logo} style={styles.logo} />
          <Text style={styles.title}>{"MONTHLY MAINTENANCE"}</Text>
          <Text
            style={styles.pageNumber}
            render={({ pageNumber, _ }) => `${pageNumber}`}
            fixed
          />
        </View>
        <View fixed style={{ marginTop: 10 }}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "left",
            }}
          >
            <Text
              style={{
                marginTop: 10,
                fontFamily: "Courier-Bold",
                fontSize: 14,
                marginLeft: 10,
              }}
            >
              MONTH
            </Text>
            <Text
              style={{
                marginLeft: 30,
                backgroundColor: "#73b569",
                color: "white",
                padding: 10,
                marginBottom: 12,
                fontSize: 17,
                borderRadius: 13,
                fontFamily: "Courier-Bold",
              }}
            >
              {props.date
                ? moment(props.date).format("MMMM")
                : moment().format("MMMM")}
            </Text>
          </View>
          <Table
            style={{ width: "510", paddingTop: 680, position: "absolute" }}
          >
            <TR>
              <TD style={styles.tData}>Prepared By: CiboENG </TD>
              <TD style={styles.tData}>
                {"Revs: " +
                  props.data.records.user.name +
                  " " +
                  props.data.records.user.surname}
              </TD>
              <TD style={styles.tData}>Authorized By: Burhan Uresin</TD>
            </TR>
            <TR>
              <TD style={styles.tData}>Issued By: Engineering</TD>
              <TD style={styles.tData}>{"MONTHLY MAINTENANCE"}</TD>
              <TD style={styles.tData}>
                {props.custom
                  ? "Document: CMMR" + moment(props.date).format("MY")
                  : "Document: MMR" + moment().format("MY")}
              </TD>
            </TR>
            <TR>
              <TD style={styles.tData}>Version 14</TD>
              <TD style={styles.tData}>
                {"Issue Date: " +
                  (props.custom
                    ? moment(props.date).endOf("month").format("MM.DD.YYYY")
                    : moment().format("MM.DD.YYYY"))}
              </TD>
              <TD style={styles.tData}>
                {"Revision Date: " + moment().format("MM.DD.YYYY")}
              </TD>
            </TR>
          </Table>
        </View>

        <Table>
          <TH>
            <TD
              weighting={0.193}
              style={{ ...styles.tHeaderData, justifyContent: "center" }}
            >
              MACHINE NAME
            </TD>
            <TD
              weighting={0.1931}
              style={{ ...styles.tHeaderData, justifyContent: "center" }}
            >
              MAINTENANCE
            </TD>
            <TD
              weighting={0.168}
              style={{ ...styles.tHeaderData, justifyContent: "center" }}
            >
              PERIOD
            </TD>
            <TD
              weighting={0.1252}
              style={{ ...styles.tHeaderData, justifyContent: "center" }}
            >
              DATE
            </TD>
            <TD
              weighting={0}
              style={{
                ...styles.tHeaderData,
                justifyContent: "center",
                fontSize: 9,
              }}
            >
              *Inspected?
            </TD>
            <TD
              weighting={0}
              style={{
                ...styles.tHeaderData,
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              ** Any potential food safety issues?
            </TD>
            <TD
              weighting={0}
              style={{
                ...styles.tHeaderData,
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              ***Any Service Required?
            </TD>
          </TH>
          {data.map((item) => {
            return item.maintenances.map((maintenance) => {
              return (
                <TR>
                  <TD
                    weighting={0.193}
                    style={{
                      ...styles.tData,
                      paddingTop: 10,
                      paddingBottom: 10,
                      paddingLeft: 8,
                    }}
                  >
                    {item.target}
                  </TD>
                  <TD
                    weighting={0.1933}
                    style={{
                      ...styles.tData,
                      paddingBottom: 10,
                      paddingTop: 10,
                      paddingLeft: 8,
                    }}
                  >
                    {maintenance.maintenance}
                  </TD>
                  <TD
                    style={{
                      ...styles.tData,
                      paddingBottom: 10,
                      paddingTop: 10,
                      paddingLeft: 25,
                    }}
                  >
                    {maintenance.period * 1 === 30
                      ? "Monthly"
                      : maintenance.period * 1 === 90
                      ? "Quarterly"
                      : "Yearly"}
                  </TD>
                  <TD style={styles.tData}>
                    {moment(props.date).isBefore(moment("2025-12-05"))
                      ? randomDate(
                          item.target + maintenance.maintenance
                        ).format("MM.DD.YYYY")
                      : moment(item.createdAt).format("MM.DD.YYYY")}
                  </TD>
                  <TD
                    style={{ ...styles.tHeaderData, justifyContent: "center" }}
                  >
                    {item.inspected.toUpperCase()}
                  </TD>
                  <TD
                    style={{ ...styles.tHeaderData, justifyContent: "center" }}
                  >
                    {item.foodSafety.toUpperCase()}
                  </TD>
                  <TD
                    style={{ ...styles.tHeaderData, justifyContent: "center" }}
                  >
                    {item.serviceRequired.toUpperCase()}
                  </TD>
                </TR>
              );
            });
          })}
        </Table>
        <View
          style={{
            marginTop: 20,
            flexDirection: "row",
            justifyContent: "left",
          }}
        >
          <Text style={{ fontFamily: "Courier-Bold", fontSize: 17 }}>
            Checked By:
          </Text>
          <Text style={{ textDecoration: "underline", fontSize: 16 }}>
            {props.data.records.user.name +
              " " +
              props.data.records.user.surname}
          </Text>
          <Text
            style={{
              marginLeft: "50",
              fontFamily: "Courier-Bold",
              fontSize: 17,
            }}
          >
            Date:
          </Text>
          <Text style={{ textDecoration: "underline", fontSize: 16 }}>
            {props.custom
              ? moment(props.date).endOf("month").format("MM.DD.YYYY")
              : moment().format("MM.DD.YYYY")}
          </Text>
        </View>
        <View
          style={{
            marginTop: 5,
            flexDirection: "row",
            justifyContent: "left",
          }}
        >
          <Text style={{ fontFamily: "Courier-Bold", fontSize: 17 }}>
            Verified By:
          </Text>
          <Text style={{ textDecoration: "underline", fontSize: 16 }}>
            Burhan Uresin
          </Text>
          <Text
            style={{ marginLeft: 45, fontFamily: "Courier-Bold", fontSize: 17 }}
          >
            Date:
          </Text>
          <Text style={{ textDecoration: "underline", fontSize: 16 }}>
            {props.custom
              ? moment(props.date).endOf("month").format("MM.DD.YYYY")
              : moment().format("MM.DD.YYYY")}
          </Text>
        </View>
      </Page>
    </Document>
  ) : null;
};

export default PreventativeReportDocument;
